import { Request } from "@xt/xtbase";
const { XtAxios4, XtAxios, setHeader } = Request;
const { asyncAwait: waitRes } = XtAxios4;
export default XtAxios4;
export { waitRes, XtAxios as axios2, setHeader };
